/* istanbul ignore file */
import { addLocaleData } from "react-intl";

export default locale =>
  import(`react-intl/locale-data/${locale}.js`).then(localeData =>
    addLocaleData(localeData.default)
  );
